import { render, staticRenderFns } from "./StandingIcon.vue?vue&type=template&id=24bdd18e&lang=pug"
import script from "./StandingIcon.vue?vue&type=script&lang=js"
export * from "./StandingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports